// CoirMats theme: page behaviour shared by every template (from the round-3 design's site.js).
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  const q = new URLSearchParams(location.search);
  const money = (n) => '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const cents = (c) => money(c / 100);

  // ---- shipping estimate before the cart. Shopify prices shipping only for a cart, so the product page and the
  // builder show an estimate that says "about". Checkout charges Shopify's calculated UPS Ground rate, no markup
  // (as DoormatsUSA), from Folcroft PA 19032 by the order's weight and the ZIP. The tables below are those checkout
  // rates, read off the store with draftOrderCalculate on 2026-10-05 (coirmats/docs/shipping-and-policies.md);
  // re-read them when UPS changes its rates (usually each January).
  // ZONES: UPS zone by 3-digit ZIP prefix, run-length coded: a letter (B-H zones 2-8, J and K Alaska, - no UPS
  // Ground rate: Puerto Rico, military, Hawaii, Pacific) then how many prefixes in a row. A prefix whose sample
  // ZIP carried a delivery-area surcharge is coded to its base zone, so remote ZIPs can pay a few dollars more.
  const ZONES = 'B6-4C8D1C16D1C2D12C4D1C1D1C1D2C5B3C1B21-10B17C1B1C5B4C1D1C6D1B1C1B1C30B30C2B6C1B6C1B4C11D1C7D5C2D3C1D4C1D7C1D1C6D9C1D16E1D2E10D1E1D1E18F2E1F2E4F1-1F1E34D4E11F1E3F1E4D1E1D18E5D2E3D15C1D17E2D9E6D14E1D1E1D1E2F1E9F3E2F5E33F2E5F17G3F6G1F1G6H1G1H4E40F4E1F1E1F3E6F2E2F17G1F15G7F16E1F3E1F2E4F38G1F2G2F4G1F4G10F1G2F1G6H1G32H38G3H1G6H1G8H12G1H36G1H3G1H19-8H25J3K2';
  const ZONE = ZONES.replace(/([A-Z-])(\d+)/g, (m, c, n) => c.repeat(+n));
  // RATE[zone][i]: the checkout rate in dollars for a parcel of W[i] lb (billed by the whole pound). UPS adds a
  // large-package charge above 50 lb and again above 110 lb, so the estimate never interpolates across those
  // steps; above 150 lb checkout shows no rate, and the order goes by freight.
  const W = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 16, 18, 20, 22, 25, 28, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80, 90, 100, 110, 120, 135, 150];
  const BANDS = [50, 110, 150];
  const RATE = {
    B: [6.65, 6.84, 7.92, 8.21, 8.5, 9.41, 9.54, 10.22, 10.33, 10.88, 12.2, 13.25, 14.12, 14.66, 15.04, 16.11, 16.41, 16.83, 17.12, 17.83, 20.2, 21.37, 21.95, 54.41, 55.58, 57.69, 59.11, 69.45, 82.56, 94.26, 103.04, 292.76, 305.31, 317.12],
    C: [6.75, 7.14, 8.59, 8.9, 9.38, 10.41, 10.93, 11.2, 11.5, 11.67, 12.61, 13.67, 14.55, 15.33, 15.91, 18.5, 19.67, 20.95, 21.23, 22.06, 24.65, 26.84, 27.6, 60.54, 61.93, 65.63, 67.39, 75.19, 85.78, 94.94, 103.15, 293.79, 305.45, 318.97],
    D: [6.84, 7.61, 8.89, 9.6, 10.18, 11.36, 11.73, 12.1, 12.3, 12.73, 13.95, 14.74, 15.56, 16.97, 18.01, 19.46, 20.98, 23.13, 23.37, 24.56, 27.96, 30.92, 32.52, 66.21, 67.81, 69.86, 72.8, 79.39, 90.37, 100.29, 107.62, 299.11, 312.1, 327.79],
    E: [7.45, 7.63, 8.91, 9.83, 10.32, 14.74, 15.61, 15.71, 15.81, 15.91, 17.43, 18.14, 19.13, 20.51, 22.78, 22.86, 24.98, 26.67, 27.2, 29.24, 33.7, 37.77, 39.45, 74.79, 77.81, 79.86, 82.51, 89.19, 96.86, 105.54, 112.36, 302.37, 314.05, 329.74],
    F: [8.45, 8.8, 10.4, 11.61, 12.17, 16.04, 16.26, 16.7, 16.8, 17.45, 19.29, 20.9, 22.71, 24.74, 26.96, 27.36, 30.58, 33.23, 33.8, 36.1, 42.14, 46.77, 49.7, 85.23, 86.69, 89.42, 91.79, 99.81, 108.17, 116.53, 123.17, 313.29, 324.97, 337.99],
    G: [8.71, 9.19, 11, 12.4, 13.11, 17.1, 17.17, 17.25, 17.73, 18.62, 22.35, 25.26, 27.05, 29.35, 32.69, 33.16, 36.99, 38.06, 38.77, 42.68, 49.04, 56, 59.42, 96.02, 97.12, 99.28, 100.26, 111.82, 121.13, 125.59, 132.39, 322.96, 335.06, 347.82],
    H: [9.25, 9.99, 12.06, 13.8, 14.7, 18.12, 18.53, 18.79, 19.5, 20.3, 24.31, 27.39, 29.82, 32.58, 36.53, 37.53, 42.49, 44.3, 45.5, 50.49, 57.44, 62.2, 66.66, 105.5, 109.68, 112.53, 114.07, 117.28, 126.01, 135.33, 142.95, 335.63, 350.85, 364.99],
    J: [31.75, 34.87, 38.03, 41.16, 44.3, 47.44, 50.58, 53.97, 57.11, 60.27, 66.58, 72.88, 79.19, 85.5, 91.8, 98.11, 107.56, 117.02, 123.33, 137.75, 153.37, 168.97, 184.59, 231.7, 247.43, 263.16, 278.9, 311.83, 344.79, 377.75, 409.23, 624.2, 673.45, 722.68],
    K: [94.81, 97.91, 100.98, 104.07, 107.16, 110.25, 113.34, 116.76, 119.86, 122.96, 129.17, 135.4, 141.59, 147.79, 154, 160.22, 169.51, 178.83, 185.02, 199.06, 214.43, 229.8, 245.16, 292.14, 307.61, 323.11, 338.58, 373.03, 407.47, 441.89, 474.8, 691.25, 742.7, 794.17],
  };
  const DAYS = { B: 1, C: 2, D: 3, E: 3, F: 4, G: 4, H: 5, J: 7, K: 7 }; // UPS Ground transit days from Pennsylvania
  const HANDLING = 1;                                          // every order, custom cuts included, ships the next business day
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
  const zoneOf = (zip) => (/^\d{5}$/.test(String(zip)) && ZONE[+String(zip).slice(0, 3)]) || 'D';
  // a variant's weight reaches the page in grams (3 lb is 1361 g), so a hair over a whole pound is that pound
  const rateFor = (z, lbs) => {
    const w = Math.max(1, Math.ceil(lbs - 0.01)), band = BANDS.findIndex((b) => w <= b), floor = band ? BANDS[band - 1] : 0;
    const r = RATE[z], i = W.findIndex((x) => x >= w);
    if (W[i] === w || W[i - 1] <= floor) return r[i];       // a measured weight, or the first one of its band
    return r[i - 1] + ((w - W[i - 1]) / (W[i] - W[i - 1])) * (r[i] - r[i - 1]);
  };
  window.CoirShip = {
    estimate(zip, lbs, big) {
      const z = zoneOf(zip);
      if (big || lbs > 150) return { freight: true };
      if (z === '-') return { quote: true };
      return { cost: Math.round(rateFor(z, lbs) * 100) / 100, zone: z };
    },
    eta(zip) {
      const t = DAYS[zoneOf(zip)] || 7, from = addBiz(new Date(), HANDLING + t), to = addBiz(new Date(), HANDLING + t + 1);
      const m = (d) => d.toLocaleDateString('en-US', { month: 'short' });
      return m(from) === m(to) ? `${m(from)} ${from.getDate()}–${to.getDate()}` : `${m(from)} ${from.getDate()} – ${m(to)} ${to.getDate()}`;
    },
  };

  // ---- scroll reveal
  const reveal = $$('[data-reveal]');
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) reveal.forEach((e) => e.classList.add('in'));
  else {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -6% 0px' });
    reveal.forEach((e, n) => { e.style.transitionDelay = (n % 4) * 60 + 'ms'; io.observe(e); });
  }

  // ---- home hero: a carousel of doorways, each mat numbered on the picture when a slide shows several
  const hero = $('[data-hero]');
  if (hero) {
    const pic = $('.hero-pic', hero), slides = $$('[data-slide]', hero), live = $('[data-hero-live]', hero), count = $('[data-hero-count]', hero);
    // a mark's X/Y is a point on the whole picture; object-fit: cover crops it, so map it onto the crop
    const place = (slide) => {
      const img = $('img', slide), W = pic.clientWidth, H = pic.clientHeight;
      if (!img || !img.naturalWidth || !W) return;
      const k = Math.max(W / img.naturalWidth, H / img.naturalHeight), w = img.naturalWidth * k, h = img.naturalHeight * k;
      const [px, py] = getComputedStyle(img).objectPosition.split(' ').map((v) => parseFloat(v) / 100);
      const cap = $('.hero-cap', slide), capW = cap ? cap.offsetWidth : 0, capT = cap ? H - cap.offsetHeight - 10 : H;
      slide.classList.remove('is-crowded');
      const boxes = $$('.hero-marks a', slide).map((a) => {
        const r = a.offsetWidth / 2 + 6;
        const x = Math.min(W - r, Math.max(r, (W - w) * px + (w * a.dataset.x) / 100));
        // a mark never sits under the caption, or under the controls in the other corner
        const floor = x < capW + r ? capT : x > W - 170 ? H - 64 : H;
        const y = Math.min(floor - r, Math.max(r, (H - h) * py + (h * a.dataset.y) / 100));
        a.style.setProperty('--tx', x.toFixed(1) + 'px');
        a.style.setProperty('--ty', y.toFixed(1) + 'px');
        return { l: x - r, r: x + r, t: y - r, b: y + r };
      });
      // on a narrow crop, marks that would run into each other stay off rather than overlap
      const hit = boxes.some((p, n) => boxes.some((q, m) => m > n && p.l < q.r && q.l < p.r && p.t < q.b && q.t < p.b));
      slide.classList.toggle('is-crowded', hit);
    };
    const placeAll = () => slides.forEach((s) => s.classList.contains('on') || s.classList.contains('is-primed') ? place(s) : null);
    slides.forEach((s) => { const img = $('img', s); if (img) img.complete ? place(s) : img.addEventListener('load', () => place(s)); });
    if ('ResizeObserver' in window) new ResizeObserver(placeAll).observe(pic);
    else window.addEventListener('resize', placeAll);

    if (slides.length > 1) {
      let cur = 0, timer = 0, paused = false;
      const still = window.matchMedia('(prefers-reduced-motion: reduce)');
      const every = (+hero.dataset.interval || 6) * 1000;
      // the next picture loads in the background once the page is idle, never with the first screen
      const prime = (n) => { const s = slides[n]; if (!s.classList.contains('on')) { s.classList.add('is-primed'); place(s); } };
      const show = (n, said) => {
        n = (n + slides.length) % slides.length;
        if (n === cur) return;
        const to = slides[n], img = $('img', to);
        to.classList.remove('is-primed');
        to.classList.add('is-in');
        const go = () => {
          if (cur !== n) return;              // a quicker click has already moved on
          place(to);
          slides.forEach((from) => {
            if (from === to || !from.classList.contains('on')) return;
            from.classList.add('is-out');
            from.classList.remove('on');
            from.setAttribute('aria-hidden', 'true');
            from.inert = true;
            setTimeout(() => from.classList.remove('is-out'), 800);
          });
          to.classList.add('on');
          to.classList.remove('is-in');
          to.removeAttribute('aria-hidden');
          to.inert = false;
          if (live) { live.setAttribute('aria-live', said ? 'polite' : 'off'); live.textContent = `Picture ${n + 1} of ${slides.length}`; }
          if (count) count.textContent = n + 1;
          setTimeout(() => prime((n + 1) % slides.length), 900);
        };
        cur = n;
        const ready = img && img.decode ? img.decode().catch(() => {}) : Promise.resolve();
        ready.then(() => requestAnimationFrame(go));
      };
      const stop = () => { clearTimeout(timer); timer = 0; };
      const plan = () => {
        stop();
        if (paused || still.matches || document.hidden) return;
        timer = setTimeout(() => { show(cur + 1); plan(); }, every);
      };
      $('[data-hero-prev]', hero).addEventListener('click', () => { show(cur - 1, true); plan(); });
      $('[data-hero-next]', hero).addEventListener('click', () => { show(cur + 1, true); plan(); });
      hero.addEventListener('mouseenter', () => { paused = true; stop(); });
      hero.addEventListener('mouseleave', () => { paused = hero.contains(document.activeElement); plan(); });
      hero.addEventListener('focusin', () => { paused = true; stop(); });
      hero.addEventListener('focusout', (e) => { if (!hero.contains(e.relatedTarget)) { paused = hero.matches(':hover'); plan(); } });
      document.addEventListener('visibilitychange', plan);
      if (still.addEventListener) still.addEventListener('change', plan);
      const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1500));
      const start = () => idle(() => prime(1));
      document.readyState === 'complete' ? start() : window.addEventListener('load', start);
      // the theme editor shows the picture being edited
      document.addEventListener('shopify:block:select', (e) => { const n = slides.indexOf(e.target); if (n >= 0) { paused = true; stop(); show(n); } });
      plan();
    }
  }

  // ---- shop panel
  const panel = $('[data-panel]'), scrim = $('[data-scrim]'), toggle = $('[data-panel-toggle]');
  const setPanel = (open) => {
    if (!panel) return;
    const hdr = $('[data-hdr]');
    if (open && hdr) panel.style.setProperty('--panel-top', Math.round(hdr.getBoundingClientRect().bottom) + 'px');
    panel.hidden = !open;
    if (scrim) scrim.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open && window.innerWidth < 860 ? 'hidden' : '';
  };
  $$('[data-panel-toggle],[data-panel-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); setPanel(panel.hidden); }));
  $$('[data-panel-close],[data-scrim]').forEach((b) => b.addEventListener('click', () => setPanel(false)));
  document.addEventListener('keydown', (e) => e.key === 'Escape' && setPanel(false));
  window.addEventListener('scroll', () => panel && !panel.hidden && window.innerWidth >= 860 && setPanel(false), { passive: true });
  if (q.get('panel') === '1') setPanel(true);

  // ---- footer: on phones the link columns start folded
  if (window.innerWidth < 860) $$('[data-ftr-cols] details').forEach((d) => (d.open = false));

  // ---- cart: the badge follows the real cart
  const badge = $('[data-cart-count]');
  const setCount = (n) => { if (!badge) return; badge.hidden = !n; badge.textContent = n; };
  const refreshCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { setCount(c.item_count); return c; });
  window.CoirCart = {
    // items: [{ id, quantity, properties }]
    add(items) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      }).then((r) => r.json().then((body) => {
        if (!r.ok) throw new Error(body.description || body.message || 'That could not be added to the cart.');
        return refreshCart();
      }));
    },
    refresh: refreshCart,
  };
  const flash = (btn, text) => {
    const old = btn.innerHTML;
    btn.textContent = text;
    btn.disabled = true;
    setTimeout(() => { btn.innerHTML = old; btn.disabled = false; }, 1600);
  };

  // a quote opened from the builder arrives with the size filled in
  const qsize = $('[data-qsizes]');
  if (qsize && q.get('size') && !qsize.value) {
    const [a, i] = q.get('size').split('x').map(Number);
    if (a && i) qsize.value = `1 mat, ${Math.floor(a / 12)}′ ${a % 12}″ long × ${Math.floor(i / 12)}′ ${i % 12}″ wide. Larger than one piece.`;
  }
  // a builder order with no online checkout yet arrives as a list of mats
  if (qsize && q.get('quote') && !qsize.value) qsize.value = q.get('quote');
  // a roll row's "Get a freight quote" arrives with the roll filled in; rolls are only ever ordered this way
  if (qsize && q.get('roll') && !qsize.value) {
    qsize.value = `Quantity 1 × ${q.get('roll')}. Please quote the freight to my ZIP.`;
    const qf = qsize.form, kind = qf && $('[name="contact[Form]"]', qf), what = qf && $('[name="contact[For]"]', qf);
    if (kind) kind.value = 'Roll freight quote';
    if (what) what.value = 'Rolls and matting';
    const zipIn = qf && $('[name="contact[Ship-to ZIP]"]', qf);
    if (zipIn) zipIn.required = true;
  }

  // ---- collection: Shopify's own filters and sort. A change reloads the page with the new query.
  const cat = $('[data-catalog]');
  if (cat) {
    const form = $('[data-filter-form]', cat);
    const filts = $$('.filt', cat);
    if (form) {
      form.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());
      form.addEventListener('submit', (e) => {
        // drop empty price fields so the URL stays clean
        $$('input[type=number]', form).forEach((i) => { if (!i.value) i.disabled = true; });
      });
    }
    filts.forEach((f) => f.addEventListener('toggle', () => f.open && filts.forEach((o) => o !== f && (o.open = false))));
    document.addEventListener('click', (e) => { if (!e.target.closest('.filt')) filts.forEach((f) => (f.open = false)); });
  }

  // ---- product page
  // Size is one grid of every size when the Size option reads "W x L", small to large, each card priced in the
  // chosen thickness; the chosen size's door fit shows in the summary above Add to cart, drawn to scale. Every
  // other option is a plain choice. The script only sets the variant id in Shopify's product form; Add to cart
  // and the accelerated checkout button submit that form.
  const pdp = $('[data-pdp]');
  if (pdp) {
    const P = JSON.parse($('[data-product]', pdp).textContent);
    const form = $('[data-pf]', pdp) || $('form[action*="/cart/add"]', pdp);
    const vid = $('[data-vid]', pdp);
    const optEl = $('[data-options]', pdp);
    const OPEN = { single: 36, side: 60, double: 72 };
    const DOORNAME = { single: 'a 3 ft door', side: 'a door with sidelights', double: 'a 6 ft pair of doors' };
    const DOORLABEL = { single: 'Fits a single door', side: 'Fits a door with sidelights', double: 'Fits a double door' };
    // the door each ready size suits (from the round-3 design); other sizes fall back to their door, runners to their length
    const NOTE = {
      '14x24': 'Fits a narrow or side door', '16x27': 'Fits a narrow or side door', '18x30': 'Fits a single door',
      '22x36': 'Fits a single door, full width', '24x39': 'Fits a single door, full width', '26x42': 'Fits a wide single door',
      '24x48': 'Fits a door with a sidelight', '30x48': 'Fits a door with sidelights', '36x48': 'Fits a door with sidelights',
      '24x60': 'Fits a double door', '36x60': 'Fits a double door', '24x72': 'Fits a double door, full width',
      '36x72': 'Fits a double door, full width', '48x72': 'Fits a double door with a deep landing',
    };
    const SCALE = new Set(['14x24', '16x27', '18x30', '22x36', '24x39', '26x42', '24x48', '30x48', '36x48', '24x60', '36x60', '24x72', '36x72', '48x72']);
    const scaleOn = pdp.dataset.scale === 'true';
    const scaleBase = pdp.dataset.scaleBase || '';

    const names = P.options.map((o) => (typeof o === 'string' ? o : o.name));
    const iSize = names.findIndex((n) => /size/i.test(n));
    const iThick = names.findIndex((n) => /thick/i.test(n));
    // inches only: a roll's "36″ × 15 yd" is not a mat size
    const parseSize = (s) => {
      const m = /(\d+(?:\.\d+)?)\s*(?:"|″|in)?\s*[x×]\s*(\d+(?:\.\d+)?)(?!\s*(?:\d|yd|yards?|ft|feet|'|′))/i.exec(s || '');
      return m ? { w: +m[1], l: +m[2] } : null;
    };
    const doorOf = (l) => (l <= 44 ? 'single' : l <= 54 ? 'side' : 'double');
    const sizeVals = iSize < 0 ? [] : [...new Set(P.variants.map((v) => v.options[iSize]))];
    const parsed = sizeVals.map(parseSize);
    const byDoor = iSize >= 0 && parsed.length > 0 && parsed.every(Boolean);
    const SZ = byDoor ? sizeVals.map((val, n) => {
      const { w, l } = parsed[n], key = `${w}x${l}`;
      const note = NOTE[key] || (l > 84 ? `A ${+(l / 12).toFixed(1)} ft runner` : DOORLABEL[doorOf(l)]);
      return { val, w, l, key, door: doorOf(l), note };
    }).sort((a, b) => a.w * a.l - b.w * b.l || a.l - b.l) : [];
    const findSize = (val) => SZ.find((s) => s.val === val);
    const label = (s) => `${s.w} × ${s.l} in`;
    // Most popular: the product's custom.popular_size or the section's size, else the size nearest 22x36 within 3 in
    // (DoormatsUSA's best seller by far, 2026-10-06); never on a roll or a size with nothing in stock
    const roll0 = pdp.hasAttribute('data-roll-quote');
    const popular = (() => {
      if (!byDoor || roll0 || SZ.length < 2) return null;
      const set = (pdp.dataset.popular || '').replace(/\s/g, '').toLowerCase();
      const near = SZ.map((s) => ({ s, d: Math.abs(s.w - 22) + Math.abs(s.l - 36) })).filter((x) => Math.abs(x.s.w - 22) <= 3 && Math.abs(x.s.l - 36) <= 3).sort((a, b) => a.d - b.d)[0];
      const p = set ? SZ.find((s) => s.key === set) : near && near.s;
      return p && P.variants.some((v) => v.options[iSize] === p.val && v.available) ? p : null;
    })();

    let cur = P.variants.find((v) => v.id === +vid.value) || P.variants.find((v) => v.available) || P.variants[0];
    if (!q.get('variant') && popular) {
      const v = P.variants.filter((x) => x.available && x.options[iSize] === popular.val).sort((a, b) => a.price - b.price)[0];
      if (v) cur = v;
    }
    const st = { opts: [...cur.options], qty: 1, zip: ($('[data-zip]', pdp) || {}).value || '19032' };
    const mto = new Set(JSON.parse(pdp.dataset.mto || '[]'));

    const match = (opts) => P.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    // the closest real variant: keep the size, then as many other choices as possible
    const settle = () => {
      let v = match(st.opts);
      if (!v) {
        const pool = P.variants.filter((x) => iSize < 0 || x.options[iSize] === st.opts[iSize]);
        v = pool.sort((a, b) => b.options.filter((o, i) => o === st.opts[i]).length - a.options.filter((o, i) => o === st.opts[i]).length)[0] || P.variants[0];
        st.opts = [...v.options];
      }
      return v;
    };
    // the values of option i that exist with the size and the earlier choices; the size itself is always free
    const valuesFor = (i) => {
      const vals = [];
      P.variants.forEach((v) => {
        const ok = v.options.every((o, j) => j === i || (j === iSize ? i === iSize || o === st.opts[j] : j < i ? o === st.opts[j] : true));
        if (ok && !vals.includes(v.options[i])) vals.push(v.options[i]);
      });
      return vals;
    };
    const multi = names.map((n, i) => new Set(P.variants.map((v) => v.options[i])).size > 1);
    const pretty = (t) => String(t).replace(/"/g, '″');
    const thickNum = (t) => {
      const m = /(\d+)?\s*(?:(\d)\/(\d)|([¼½¾⅛⅜⅝⅞]))?/.exec(t || '');
      if (!m) return 0;
      const FR = { '¼': 0.25, '½': 0.5, '¾': 0.75, '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875 };
      return (+m[1] || 0) + (m[2] ? m[2] / m[3] : FR[m[4]] || 0);
    };
    const inch = (n) => {
      const w = Math.floor(n), f = n - w, F = { 0.25: '¼', 0.5: '½', 0.75: '¾' };
      return (w || !F[f] ? w : '') + (F[f] || '') + '″';
    };

    // the door opening as a line, the mat as its footprint below it: plan view, every size at one scale
    const glyph = (v) => {
      const k = 1, W = 80, H = 52, cx = W / 2, o = OPEN[v.door] * k, m = Math.min(v.l * k, W - 2), h = Math.min(v.w * k, H - 9);
      let d = `<path d="M${cx - 18 * k} 2.5H${cx + 18 * k}" stroke-width="3"/>`;
      if (v.door === 'side') d += `<path d="M${cx - o / 2} 2.5H${cx - 18 * k - 2}M${cx + 18 * k + 2} 2.5H${cx + o / 2}" stroke-width="1.5"/>`;
      if (v.door === 'double') d = `<path d="M${cx - o / 2} 2.5H${cx - 1}M${cx + 1} 2.5H${cx + o / 2}" stroke-width="3"/>`;
      return `<svg width="${W}" height="${H}" viewBox="0 0 ${W} ${H}" fill="none" stroke="currentColor" role="img" aria-label="${label(v)}, drawn to scale against ${DOORNAME[v.door]}">${d}<rect x="${cx - m / 2}" y="7.5" width="${m}" height="${h}" rx="1.5" fill="#C9A15C" stroke="#7A561C" stroke-width="1"/></svg>`;
    };

    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const fieldset = (title, right, body) => `<fieldset class="po"><legend><span>${esc(title)}</span>${right}</legend>${body}</fieldset>`;

    const short = (t) => pretty(t).replace(/\s*thick$/i, '');
    // a size card's state in the current choices: its price, or why it cannot be had as chosen
    const sizeState = (s) => {
      const all = P.variants.filter((v) => v.options[iSize] === s.val);
      const v = match(st.opts.map((o, j) => (j === iSize ? s.val : o)));
      if (rollQuote) return { price: v ? v.price : Math.min(...all.map((x) => x.price)), off: !v, note: v ? '' : 'Other options' };
      if (!all.some((x) => x.available)) return { price: (v || all[0]).price, off: true, note: 'Sold out' };
      if (v) return { price: v.price, off: !v.available || mto.has(v.id), note: !v.available ? 'Sold out' : mto.has(v.id) ? 'Made to order' : '' };
      // not made in this choice: name what it comes in, such as "2″ only"
      const j = st.opts.findIndex((o, k) => k !== iSize && !all.some((x) => x.options[k] === o));
      if (j < 0) return { price: Math.min(...all.map((x) => x.price)), off: true, note: 'Other options' };
      const vals = [...new Set(all.map((x) => x.options[j]))];
      return { price: Math.min(...all.map((x) => x.price)), off: true, note: vals.length === 1 ? `${short(vals[0])} only` : `Not in ${short(st.opts[j])}` };
    };
    const drawOptions = () => {
      let html = '';
      names.forEach((name, i) => {
        if (i === iSize && byDoor) {
          // one radio group of every size, small to large; the custom cut is a link after it, in the same grid
          const cards = SZ.map((s) => {
            const on = s.val === st.opts[i], x = sizeState(s), pop = popular && popular.val === s.val;
            const sr = `${s.w} by ${s.l} inches, ${cents(x.price)}${x.note ? ', ' + x.note : ''}${pop ? ', most popular' : ''}`;
            return `<button type="button" role="radio" aria-checked="${on}" tabindex="${on ? 0 : -1}" data-opt="${i}" data-val="${esc(s.val)}" aria-label="${esc(sr)}"${x.off ? ' class="off"' : ''}>${pop ? '<em>Most popular</em>' : ''}<b>${s.w} × ${s.l}</b><span>${x.note && x.off ? esc(x.note) : cents(x.price)}</span></button>`;
          }).join('');
          const cut = cutUrl ? `<a class="po-cut" href="${esc(cutUrl)}"><b>Custom size</b><span>Cut to fit</span></a>` : '';
          html += fieldset(name, $('#fit') ? '<a href="#fit">How to choose</a>' : '', `<div class="po-sizes"><div class="po-radios" role="radiogroup" aria-label="${esc(name)}">${cards}</div>${cut}</div>`);
          return;
        }
        if (i === iSize && multi[i]) {
          // sizes that are not "W x L", such as a roll's "36″ × 15 yd": the same priced cards, in the store's order
          const cards = sizeVals.map((val) => {
            const on = val === st.opts[i], x = sizeState({ val });
            return `<button type="button" role="radio" aria-checked="${on}" tabindex="${on ? 0 : -1}" data-opt="${i}" data-val="${esc(val)}" aria-label="${esc(`${pretty(val)}, ${cents(x.price)}${x.note ? ', ' + x.note : ''}`)}"${x.off ? ' class="off"' : ''}><b>${esc(pretty(val))}</b><span>${x.note && x.off ? esc(x.note) : cents(x.price)}</span></button>`;
          }).join('');
          html += fieldset(name, '', `<div class="po-sizes po-sizes--wide"><div class="po-radios" role="radiogroup" aria-label="${esc(name)}">${cards}</div></div>`);
          return;
        }
        const vals = valuesFor(i);
        if (!multi[i] || (vals.length < 2 && i !== iThick)) return;
        if (i === iThick) {
          vals.sort((a, b) => thickNum(a) - thickNum(b));
          const btns = vals.map((t) => {
            const v = match(st.opts.map((o, j) => (j === i ? t : o))) || P.variants.find((x) => x.options[i] === t && (iSize < 0 || x.options[iSize] === st.opts[iSize]));
            const n = thickNum(t);
            return `<button type="button" data-opt="${i}" data-val="${esc(t)}" aria-pressed="${t === st.opts[i]}"><i style="height:${Math.max(4, Math.round(n * 9))}px"></i><b>${esc(pretty(t))}${v ? ' · ' + cents(v.price) : ''}</b>${n ? `<span>Needs a ${inch(n + 0.25)} door gap</span>` : ''}</button>`;
          }).join('');
          html += fieldset(name, `<b>${esc(pretty(st.opts[i]))}${vals.length < 2 ? ' only in this size' : ''}</b>`, `<div class="po-thick${vals.length < 2 ? ' one' : ''}">${btns}</div>`);
          return;
        }
        const btns = vals.map((val) => `<button type="button" data-opt="${i}" data-val="${esc(val)}" aria-pressed="${val === st.opts[i]}">${esc(val)}</button>`).join('');
        html += fieldset(name, `<b>${esc(st.opts[i])}</b>`, `<div class="po-door po-plain" role="group" aria-label="${esc(name)}">${btns}</div>`);
      });
      // the choice in one line above Add to cart: size, thickness, the door it fits, when it ships, the price
      const s = byDoor ? findSize(st.opts[iSize]) : null;
      if (s && !rollQuote) {
        const th = iThick >= 0 ? `${short(st.opts[iThick])} thick` : '';
        const other = st.opts.filter((o, j) => j !== iSize && j !== iThick && multi[j]).map(pretty);
        const when = !cur.available ? 'Sold out' : mto.has(cur.id) ? 'Made to order' : shipLine;
        html += `<div class="po-sum">${glyph(s)}<p><b>${[label(s), th, ...other].filter(Boolean).join(' · ')} · ${cents(cur.price)}</b><span>${esc(s.note)} · ${esc(when)}</span></p></div>`;
      }
      optEl.innerHTML = html;
    };

    const gal = $('[data-gallery]', pdp), track = gal && $('[data-track]', gal), dots = gal ? $$('[data-dots] i', gal) : [];
    if (track) {
      let st0;
      track.addEventListener('scroll', () => {
        clearTimeout(st0);
        st0 = setTimeout(() => { const n = Math.round(track.scrollLeft / track.clientWidth); dots.forEach((d, i) => d.classList.toggle('on', i === n)); }, 60);
      });
    }
    const lbox = $('[data-lbox]', pdp);
    if (gal && lbox) {
      gal.addEventListener('click', (e) => {
        const b = e.target.closest('[data-zoom]');
        if (!b) return;
        const img = $('img', b), big = $('img', lbox);
        big.src = img.currentSrc || img.src;
        big.alt = img.alt;
        lbox.hidden = false;
      });
      lbox.addEventListener('click', () => (lbox.hidden = true));
      document.addEventListener('keydown', (e) => e.key === 'Escape' && (lbox.hidden = true));
    }

    // rolls: no cart; the quote form carries the chosen roll
    const rollQuote = roll0;
    // a size grid has no custom-cut link under the buy box; the products the section names end the grid with a card
    const cutLink = $('.pb-cut', pdp), grid = byDoor && !rollQuote;
    const cutUrl = grid ? pdp.dataset.cutCard || '' : '';
    if (grid && cutLink) cutLink.hidden = true;
    const shipLine = pdp.dataset.ship || 'Ships next business day';
    const rqRoll = $('[data-rq-roll]', pdp);

    const fit = $('[data-fit]');
    // a choice: redraw, keep focus on the chosen card, and tell the store's analytics which size was picked
    const pick = (i, val) => {
      st.opts[i] = val;
      render();
      const again = $(`[data-opt="${i}"][data-val="${CSS.escape(val)}"]`, pdp);
      if (again) again.focus({ preventScroll: true });
      if (i !== iSize) return;
      const ev = { product: P.handle, size: val, variant: cur.id, sku: cur.sku || '', price: cur.price / 100, available: cur.available };
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('size_selected', ev); } catch (x) { /* analytics never blocks the picker */ }
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'size_selected', ...ev });
    };
    const render = () => {
      cur = settle();
      vid.value = cur.id;
      drawOptions();
      const s = byDoor ? findSize(st.opts[iSize]) : null;
      const rest = st.opts.map((o, i) => (i === iSize || !multi[i] ? '' : i === iThick ? `${short(o)} thick` : pretty(o))).filter(Boolean);
      const note = s ? [label(s), ...rest].join(' · ') : cur.title;
      $$('[data-price]').forEach((e) => (e.textContent = cents(cur.price)));
      $$('[data-priceNote]').forEach((e) => (e.textContent = note));
      const qtyEl = $('[data-qty]', pdp), qtyIn = $('[data-qty-input]', pdp);
      if (qtyEl) qtyEl.textContent = st.qty;
      if (qtyIn) qtyIn.value = st.qty;
      $$('[data-atc]').forEach((b) => (b.disabled = !cur.available));
      const atcLabel = $('[data-atc-label]', pdp);
      if (atcLabel) atcLabel.innerHTML = cur.available ? `Add to cart · <span data-total>${cents(cur.price * st.qty)}</span>` : 'Sold out';
      if (rqRoll) rqRoll.value = `${P.title} · ${cur.title} · ${cents(cur.price)} a roll`;
      if (history.replaceState) history.replaceState(null, '', `${location.pathname}?${new URLSearchParams({ ...Object.fromEntries(q), variant: cur.id })}`);

      // shipping by ZIP, before the cart: the variant's weight, or an estimate from its area when it has none
      const th = iThick >= 0 ? thickNum(st.opts[iThick]) : 1;
      const lbs = (cur.weight ? cur.weight / 453.6 : s ? (s.w * s.l / 144) * (th <= 1 ? 1.9 : 3.3) : 3) * st.qty;
      const est = window.CoirShip.estimate(st.zip, lbs, s && s.l > 96);
      const shipEl = $('[data-ship]', pdp), etaEl = $('[data-eta]', pdp);
      if (shipEl) shipEl.textContent = est.freight ? 'Travels by freight, quoted before you pay'
        : est.quote ? `No UPS Ground to ${st.zip}; we quote shipping by email` : `Shipping about ${money(est.cost)} to ${st.zip}`;
      if (etaEl) etaEl.textContent = window.CoirShip.eta(st.zip);

      if (!s) { if (fit) fit.hidden = true; return; }
      if (!fit) return;
      fit.hidden = false;
      $$('[data-sizeLabel]').forEach((e) => (e.textContent = label(s)));
      // the chosen size at a matching door, to scale: in the gallery and in "Size at the door"
      const fitImg = $('[data-fitimg]', fit);
      if (scaleOn && SCALE.has(s.key) && scaleBase) {
        const src = `${scaleBase}real-size-${s.key}.webp`, set = `${scaleBase}real-size-${s.key}-440.webp 440w, ${src} 880w`;
        const alt = `${P.title}, ${label(s)}, drawn to scale at ${DOORNAME[s.door]}`;
        [$('[data-scale-slide] img', pdp), fitImg].forEach((im) => { if (im) { im.srcset = set; im.src = src; im.alt = alt; } });
      } else if (cur.featured_image && fitImg) {
        fitImg.removeAttribute('srcset');
        fitImg.src = cur.featured_image.src;
        fitImg.alt = cur.featured_image.alt || P.title;
      }
      const r = s.l / OPEN[s.door], d = DOORNAME[s.door].replace(/^a /, 'the ');
      $('[data-fitlong]', fit).textContent = (r < 0.72 ? `At ${s.l}″ long this mat is shorter than ${d} is wide, which suits a narrow or side door.`
        : r < 0.95 ? `At ${s.l}″ long this mat covers most of ${d}.`
          : r <= 1.1 ? `At ${s.l}″ long this mat spans ${d} edge to edge, the proportion most people want.`
            : `At ${s.l}″ long this mat runs a little past ${d} on each side, which suits a wide step.`)
        + ` ${s.w}″ of width ${s.w >= 30 ? 'gives two full strides on the coir.' : s.w >= 22 ? 'takes a full stride.' : 'takes one good wipe of each foot.'}`;
    };

    pdp.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b || !pdp.contains(b)) return;
      if (b.dataset.opt != null) pick(+b.dataset.opt, b.dataset.val);
      else if (b.dataset.q) { st.qty = Math.max(1, st.qty + +b.dataset.q); render(); }
    });
    // the size cards are one radio group: arrows move the choice, Home and End jump to the ends
    pdp.addEventListener('keydown', (e) => {
      const b = e.target.closest('[role=radio]');
      if (!b) return;
      const all = $$('[role=radio]', b.parentElement), n = all.indexOf(b);
      const to = { ArrowRight: n + 1, ArrowDown: n + 1, ArrowLeft: n - 1, ArrowUp: n - 1, Home: 0, End: all.length - 1 }[e.key];
      if (to == null) return;
      e.preventDefault();
      const t = all[(to + all.length) % all.length];
      pick(+t.dataset.opt, t.dataset.val);
    });
    const zip = $('[data-zip]', pdp);
    if (zip) {
      zip.addEventListener('change', () => {
        const z = zip.value.replace(/\D/g, '').slice(0, 5);
        if (z.length === 5) st.zip = z;
        zip.value = st.zip;
        render();
      });
      zip.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); zip.blur(); } });
    }
    // Add to cart stays on the page; the accelerated checkout button submits the form itself
    const err = $('[data-err]', pdp);
    if (form) form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (rollQuote) return;
      const btns = $$('[data-atc]');
      btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
      if (err) err.hidden = true;
      window.CoirCart.add([{ id: cur.id, quantity: st.qty }])
        .then(() => btns.forEach((b) => flash(b, 'Added to cart')))
        .catch((x) => { if (err) { err.textContent = x.message; err.hidden = false; } })
        .finally(() => btns.forEach((b) => b.removeAttribute('aria-busy')));
    });
    render();
    // one sticky bar, and only once the main button has scrolled away
    const sbar = $('[data-sbar]', pdp), row = $('.buy-row', pdp) || $('#roll-quote', pdp);
    if (sbar && row && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => sbar.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(row);
  }
})();
